export const REMINDER_LABELS: { [key: number]: string } = {
  0: 'Start time',
  5: '5 mins',
  15: '15 mins',
  30: '30 mins',
  60: '1 hour',
  120: '2 hours',
  240: '4 hours',
  1440: '1 day',
  2880: '2 days',
  10080: '7 days',
};